/**
 * Reports what the visitor's pointing device can actually do, rather than guessing
 * from screen width. Updates live when a mouse is attached or DevTools toggles
 * device emulation.
 */

import { useCallback, useEffect, useState } from "react";

const COARSE_POINTER = "(pointer: coarse)";
const ANY_HOVER = "(any-hover: hover)";

const DESKTOP_DEFAULTS = { isCoarsePointer: false, canHover: true };

function supportsMatchMedia() {
  return typeof window !== "undefined" && typeof window.matchMedia === "function";
}

export default function usePointerCapabilities() {
  const read = useCallback(() => {
    if (!supportsMatchMedia()) return DESKTOP_DEFAULTS;

    return {
      isCoarsePointer: window.matchMedia(COARSE_POINTER).matches,
      canHover: window.matchMedia(ANY_HOVER).matches,
    };
  }, []);

  const [capabilities, setCapabilities] = useState(read);

  useEffect(() => {
    if (!supportsMatchMedia()) return undefined;

    const lists = [window.matchMedia(COARSE_POINTER), window.matchMedia(ANY_HOVER)];
    const update = () => setCapabilities(read());

    update();
    lists.forEach((list) => list.addEventListener("change", update));
    return () => lists.forEach((list) => list.removeEventListener("change", update));
  }, [read]);

  return capabilities;
}
